module.exports = __webpack_public_path__ + "img/icon-total-creators.817083f1.svg";